// extracted by mini-css-extract-plugin
export default {"bulletins_content":"style_bulletins_content__e5Of2","bulletin_single":"style_bulletin_single__MF21J","bulletin_info":"style_bulletin_info__p4f0f"};